export const PROM_EMBEDDED_SIGNUP = 'prom_embedded_signup';
export const PROM_CAMPAIGN_LIVE = 'prom_campaign_live';
export const PROM_CAMPAIGN_STATS_UPDATE = 'prom_campaign_stats_update';
export const PROM_TEMPLATE_SUBMIT = 'prom_template_submit';
